import React from 'react';
import { Typography, Box } from '@mui/material';

function Reports() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Reports
      </Typography>
      <Typography variant="body1">
        Reports functionality coming soon...
      </Typography>
    </Box>
  );
}

export default Reports; 